// extracted by mini-css-extract-plugin
export default {"nombreTorneo":"UltimoTorneoTipo_nombreTorneo__XL8EE","campeon":"UltimoTorneoTipo_campeon__-IlFG"};